import {decorate, injectable} from 'inversify';
import {TAlbum} from '../../../../typings/todo';
import {fetchAlbumData} from '../../albumProvider/albumProvider';
import {IAlbumProvider} from './IAlbumProvider';

export class AlbumProvider implements IAlbumProvider {
  fetch(albumId: string): Promise<{album: TAlbum}> {
    return fetchAlbumData(albumId);
  }
}

decorate(injectable(), AlbumProvider);
